// extracted by mini-css-extract-plugin
module.exports = {"reqErrorText":"DeleteTransactionModal_reqErrorText__2sp6a"};